class ComponentProductWishlist extends HTMLElement {
  constructor() {
    super();
    this.products_wishlist = localStorage.getItem("products_wishlist")
      ? JSON.parse(localStorage.getItem("products_wishlist"))
      : [];
    this.product_id = this.getAttribute("data-target-item") || "";
    this.elementWishlist = this.querySelector("[data-target-wishlist]");
    this.init();
  }

  async init() {
    if (!sessionStorage.getItem("f_visit_pdp")) {
      try {
        const customerId = this.elementWishlist.getAttribute("data-target-wishlist")
          ? this.sanitizeData(this.elementWishlist.getAttribute("data-target-wishlist"))
          : null;

        if (customerId) {
          const productsWishlist =  await this.getProductsWishlist(customerId);

          if (productsWishlist && productsWishlist.products) {
            localStorage.setItem("products_wishlist", JSON.stringify(productsWishlist.products));
            sessionStorage.setItem("f_visit_pdp", true);
          }
        }
      } catch (error) {
        console.log("Error: get wishlist");
      }
    }

    this.renderWishlistComponent();

    if (this.elementWishlist) {
      this.elementWishlist.addEventListener("click", async (event) => {
        const customerId = this.elementWishlist.getAttribute("data-target-wishlist")
          ? this.sanitizeData(this.elementWishlist.getAttribute("data-target-wishlist"))
          : null;
        const productId = this.product_id ? this.sanitizeData(this.product_id) : null;

        try {
          const response = await this.requestUpdateWishlist(customerId, productId);

          if (response && response.products) {
            localStorage.setItem("products_wishlist", JSON.stringify(response.products));
          }

          this.renderWishlistComponent();
        } catch (error) {
          console.log("Error: update wishlist");
        }
      });
    }
  }

  checkProductInWishlist(ids, productId) {
    if (ids && ids.length < 1) {
      return false;
    }

    const product = ids.find((id) => id == productId);

    if (product) {
      return true;
    }

    return false;
  }

  async getProductsWishlist(id) {
    return await fetch(`https://shopify-admin-api.basicamente.com/wishlist/basicamente/${id}`)
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          return data;
        }
      });
  }

  renderWishlistComponent() {
    const idsLocalStorage = localStorage.getItem("products_wishlist")
      ? JSON.parse(localStorage.getItem("products_wishlist"))
      : [];
    const wishlistIcon = this.querySelector(".Wishlist__Icon");

    if (this.checkProductInWishlist(idsLocalStorage, this.product_id)) {
      if (this.elementWishlist && wishlistIcon) {
        const productAdded =
          '<svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.55284 3.00012C7.93598 3.00012 7.23841 3.06514 6.57209 3.29224C2.55494 4.60387 1.26341 8.894 2.39877 12.43L2.40354 12.4448L2.40877 12.4595C3.03435 14.2174 4.04226 15.8127 5.35336 17.1249L5.36091 17.1324L5.36862 17.1398C7.23782 18.9323 9.27254 20.4953 11.4756 21.8515L11.9934 22.1703L12.5147 21.8573C14.7226 20.5315 16.7964 18.9254 18.6432 17.1474L18.649 17.1419L18.6547 17.1362C19.9771 15.8215 20.9851 14.2144 21.6015 12.4549L21.6066 12.4402L21.6113 12.4253C22.7251 8.89703 21.4401 4.60176 17.4507 3.30948C16.7976 3.09221 16.1236 3.00012 15.4648 3.00012C13.9828 3.00011 12.8858 3.62064 12.0004 4.25309C11.1219 3.62545 10.0176 3.00012 8.55284 3.00012Z" fill="#000000"/></svg>';
        wishlistIcon.innerHTML = productAdded;
        this.elementWishlist.innerText = "Adicionado na wishlist";
      }
    } else {
      if (this.elementWishlist && wishlistIcon) {
        const productToAdd =
          '<svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.55284 3.00012C7.93598 3.00012 7.23841 3.06514 6.57209 3.29224C2.55494 4.60387 1.26341 8.894 2.39877 12.43L2.40354 12.4448L2.40877 12.4595C3.03435 14.2174 4.04226 15.8127 5.35336 17.1249L5.36091 17.1324L5.36862 17.1398C7.23782 18.9323 9.27254 20.4953 11.4756 21.8515L11.9934 22.1703L12.5147 21.8573C14.7226 20.5315 16.7964 18.9254 18.6432 17.1474L18.649 17.1419L18.6547 17.1362C19.9771 15.8215 20.9851 14.2144 21.6015 12.4549L21.6066 12.4402L21.6113 12.4253C22.7251 8.89703 21.4401 4.60176 17.4507 3.30948C16.7976 3.09221 16.1236 3.00012 15.4648 3.00012C13.9828 3.00011 12.8858 3.62064 12.0004 4.25309C11.1219 3.62545 10.0176 3.00012 8.55284 3.00012Z" stroke="#000000"/></svg>';
        wishlistIcon.innerHTML = productToAdd;
        this.elementWishlist.innerText = "Adicionar a wishlist";
      }
    }
  }

  sanitizeData(data) {
    return data.replace(/\D/g, "");
  }

  async requestUpdateWishlist(customerId, productId) {
    return await fetch(`https://shopify-admin-api.basicamente.com/wishlist/basicamente/${customerId}/${productId}`)
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          return data;
        }
      });
  }
}

customElements.define("component-product-wishlist", ComponentProductWishlist);
